<template>
  <div>
    <page-header :latestVersionUrl="latestVersionUrl" @log-out="logout" />

    <div align="center" id="organisations-content">
      <h1 id="organisation-title" align="left">Select your organisation</h1>

      <div align="left" v-show="allOrganisations.length > 0">
        <b-input class="search-bar" align="left" placeholder="Search for an organisation" v-model="organisationSearch" />
      </div>

      <div id="organisation-list" v-show="!hasLoaded || organisations.length > 0">
        <b-overlay :show="!hasLoaded" class="loading-overlay" bg-color="rgb((35, 37, 45)">
          <b-list-group v-for="(organisation, index) in organisations" :key="index" class="list-group">
            <b-list-group-item button class="list-item" @click="selectOrganisation(organisation.id, organisation.name)">
              <div align="left" class="organisation-image-div">
                <b-img rounded="circle" class="organisation-image" :src="organisation.logoUrl" width="40" height="40" onerror="this.style='display: none';" />
              </div>
              <div align="left">
                <p class="organisation-name">{{organisation.name}}</p>
              </div>
              <div align="right">
                <img class="chevron-right" src="@/assets/selector_chevron_right.png" alt="Chevron Right" />
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-overlay>
      </div>

      <div class="empty-warning" v-show="hasLoaded && allOrganisations.length <= 0">
        <p>You don’t have any organisations associated to this account.</p>
        <br />
        <p>Think something is wrong? Email us at <u>customersuccess@cortextech.io</u> to let us know and we’ll add the correct organisation(s) to your account.</p>
      </div>
      
      <div class="page-footer" />
    </div>
  </div>
</template>

<script>
import PageHeader from './PageHeader.vue';

export default {
  components: { PageHeader },
  data() {
    return {
      allOrganisations: [],
      organisations: [],
      hasLoaded: false,
      organisationSearch: ''
    }
  },
  methods: {
    logout() {
      this.allOrganisations = [],
      this.organisations = []
      this.hasLoaded = false;
      this.organisationSearch = ''
      this.$emit('log-out')
    },
    selectOrganisation(organisationId, organisationName) {
      this.organisationSearch = ''
      this.$emit("selected-organisation-id", organisationId, organisationName)
    },
    async getOrganisations() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.accessToken);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      const baseUrl = `https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}cast-licensing-api.incrowdsports.com/v1`
      return await fetch(`${baseUrl}/organisations`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data.data
        })
        .catch(error => console.log('error', error));
    },
    filterOrganisations() {
      if (this.organisationSearch.length <= 0) {
        this.organisations = this.allOrganisations
      } else {
        this.organisations = this.allOrganisations.filter(this.organisationSelector);
      }
    },
    organisationSelector(organisation) {
      return organisation.name.toUpperCase().includes(this.organisationSearch.toUpperCase());
    }
  },
  props: {
    accessToken: String,
    latestVersionUrl: String
  },
  watch: {
    accessToken: {
      immediate: true,
      async handler() {
        if (this.accessToken.length > 0){
          this.allOrganisations = await this.getOrganisations()
          this.filterOrganisations()
          this.hasLoaded = true;
        }
        else {
          this.organisations = []
        }
      }
    },
    organisationSearch: {
      immediate: true,
      handler() {
        this.filterOrganisations()
      }
    }
  },
}
</script>

<style>
#organisations-content {
  padding-left: 10%;
  padding-right: 10%;
}
#organisation-title {
  margin-top: 64px;
  text-align: left;
}
.search-bar {
  margin-top: 16px;
  max-width: 384px;
  width: 100%;
  height: 40px;

  background: rgba(57, 62, 68, 1);
  
  border: 1px solid rgba(89, 92, 102, 1);
  box-sizing: border-box;
  border-radius: 4px;

  color: white;
}
.search-bar::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: rgb(185, 188, 192);
            opacity: 1; /* Firefox */
}

.search-bar:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: rgb(185, 188, 192);
}

.search-bar::-ms-input-placeholder { /* Microsoft Edge */
            color: rgb(185, 188, 192);
 }
.search-bar:focus {
  background: rgba(57, 62, 68, 1);
  color: white;

  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 4px;
}
#organisation-list {
  margin-top: 28px;
}
.list-item {
  height: 60px;

  background: rgba(35, 37, 45, 1);
  
  border: 1px solid rgba(73, 76, 85, 1);
  border-bottom: 0px;

  color: white;
}
.list-item:hover {
  background: rgba(57, 62, 68, 1);
}
.list-group:last-child {
  border-bottom: 1px solid rgba(57, 62, 68, 1);
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.list-group:not(:last-child) {
  border-radius: 0px;
}
.list-group:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.organisation-image-div {
  float: left;
  min-height: 40px;
  width: 40px;
  height: 40px;

  background-color: rgba(73, 76, 85, 1);

  border: 1px solid rgba(89, 92, 102, 1);
  box-sizing: border-box;
  border-radius: 20px;
}
.organisation-name {
  float: left;
  margin-left: 16px;
  margin-top: 10px;
}
.chevron-right {
  float: right;
  margin-top: 8px;
}
.empty-warning {
  margin-top: 16px;
  padding: 50px;

  background: rgba(35, 37, 45, 1);

  border: 1px solid rgba(73, 76, 85, 1);
  box-sizing: border-box;
  border-radius: 4px;
}
#organisation-title,
#licence-title,
#licence-details-title {
  /* Desktop/H1 Heading */
  color: white;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 35px;
}
.loading-overlay {
  min-height: 100px;
  color: white;
}
@media screen and (max-width: 475px) {
  #organisations-content{
    padding-left: 16px;
    padding-right: 16px;
  }
  .search-bar {
    max-width: none;
  }
  #organisation-title,
  #licence-title,
  #licence-details-title {
    /* Desktop/H1 Heading */
    color: white;

    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
  }
}
</style>